import { LitElement, html } from 'lit';
import styles from './styles';
/**
 * @slot - The element's content.
 *
 * @csspart base - The element's base container.
 */
export default class AmityekoTgTitle extends LitElement {
    render() {
        return html `<h2 part="base"><slot></slot></h2>`;
    }
}
AmityekoTgTitle.styles = styles;
if (!customElements.get('amityeko-tg-title')) {
    customElements.define('amityeko-tg-title', AmityekoTgTitle);
}
//# sourceMappingURL=index.js.map